export const ChangeContractSteps = (activeIndex, t) => {
  return [
    {
      title: t('Select new plan'),
      active: activeIndex == 1,
    },
    {
      title: t('Confirmation'),
      active: activeIndex == 2,
    },
  ];
};
